import { auth } from "../context/AppContext";
import { FileLibrary } from "../context/FileLibraryContext";
import { sendAxiosPost } from "./ServerUtil";

export const firebaseConfig = {
    apiKey: "AIzaSyD8x7WYSTceKcdIxkX_GvwauLGmxoi14AE",
    authDomain: "ipwdfb.firebaseapp.com",
    projectId: "ipwdfb",
    storageBucket: "ipwdfb.firebasestorage.app",
    messagingSenderId: "999595486312",
    appId: "1:999595486312:web:561cf6ca260cf23f655fdd",
    measurementId: "G-0H6GCPGNKQ"
};

export interface UserData {
    patreonId: string | null; // patreon id of the user
    tierId: number; // entitled patreon tier id
    fileLibrary: FileLibrary | null;
    isAdmin: boolean;
}

export async function deleteFirebaseAccount(): Promise<boolean> {
    const response = await sendAxiosPost("/api/deleteFirebaseAccount", null, true);
    return response?.success || false;
}